<span *ngIf="allowMarkup" class="title" [innerHTML]="title"></span>
<span *ngIf="!allowMarkup" class="title">{{title}}</span>
